/* eslint-disable */
import React, { useEffect, useState, useContext, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Button } from 'syngenta-react-components'
import Select from '../../dpe-usco/components/Select/Select'
import clear from '../../assets/icons/clear.svg'
import { sendToSign, getAssignments, postContractByIdWithDraft, getHighestRole } from '../../services/apiHelper'
import { withRouter } from 'react-router-dom'
import { GlobalContext } from '../../services/context'
import { reducePhoneNumber } from '../../services/utils'
import closeIcon from '../../assets/icons/close.svg'
import checkIcon from '../../assets/icons/check.svg'
import TableStatus from '../subComponents/TableStatus/TableStatus'

const SendForSigningForm = ({
  contract_id,
  contractDataPending,
  setShowModal,
  contractData,
  growerDetails,
  growerSigner,
  grainReceiverDetails,
  resellerDetails,
  resend,
  handleResend,
  resendLoading,
  setResendLoading,
  resendMessage,
  setDisableSentSignBtn
}) => {
  const canceled = useRef(false)
  const { control } = useForm()
  const {
    register,
    errors,
    clearError,
    handleSubmit,
    reset,
    getValues
  } = useForm()


  let phone = growerSigner && growerSigner.phone ?  growerSigner.phone : growerDetails?.phone
  if(phone && phone.length > 10) phone = phone.substr(1)
  if(phone===null) phone = ''
  let signerEmail = growerSigner && growerSigner.email ?  growerSigner.email : ''
  if(signerEmail===null) signerEmail = ''
  let delivery_choice = growerSigner && (growerSigner.delivery_choice.toLowerCase() === 'email') ?  'email' : 'phone'
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const [grainReceiverData, setGrainReceiverData] = useState()
  const [resellerData, setResellerData] = useState()
  const [toggleInput, setToggleInput] = useState(false)
  const [growerPhone, setGrowerPhone] = useState(phone)
  const [submissionStatus, setSubmissionStatus] = useState()
  const [phoneError, setPhoneError] = useState(false)
  const [growerEmail, setGrowerEmail] = useState(signerEmail)
  const [growerDeliveryChoice, setGrowerDeliveryChoice] = useState(delivery_choice)
  const [emailError, setEmailError] = useState(false)
  const [resendSubmissionStatus, setResendSubmissionStatus] = useState(resendLoading)
  const [userInfo, setUserInfo] = useState({})

  useEffect(() => {
    setResendSubmissionStatus(resendLoading)
  },[resendLoading])
  
  const handleCancelModal = () => {
    trackEvent('send_for_signing_canceled', {
      contractId: contractData.contract_id
    })
    setToggleInput(false)
    setSubmissionStatus()
    setShowModal(false)
    reset()
    clearError()
  }

  const hideModal = () => { setShowModal(false) }

  const inputDecider = arg => {
    setToggleInput(prev => !prev)
    if(growerDeliveryChoice.toLowerCase() === 'email') {
      trackEvent('edit_grower_email_clicked', {
        contractId: contractData.contract_id,
        growerEmail
      })
    } else {
      trackEvent('edit_grower_phone_clicked', {
        contractId: contractData.contract_id,
        growerPhone
      })
    }
  }

  const handlePhoneNumber = () => {
    const newGrowerPhone = getValues().phone.replace(/^(\+)|\D/g, '$1')
    setGrowerPhone(newGrowerPhone)
  }

  const handleConfirmPhoneNumber = () => {
    const newGrowerPhone = getValues().phone.replace(/^(\+)|\D/g, '$1')
    setToggleInput(false)
    setGrowerPhone(newGrowerPhone)
    trackEvent('edit_grower_phone_confirmed', {
      contractId: contractData.contract_id,
      growerPhone: newGrowerPhone
    })
  }

  const handleEmail = () => {
    const newGrowerEmail = getValues().email
    setGrowerEmail(newGrowerEmail)
  }

  const handleConfirmEmail = () => {
    const newGrowerEmail = getValues().email
    setToggleInput(false)
    setGrowerEmail(newGrowerEmail)
    trackEvent('edit_grower_email_confirmed', {
      contractId: contractData.contract_id,
      growerEmail: newGrowerEmail
    })
  }

  const handleCancelInput = () => {
    setToggleInput(false)
    trackEvent('edit_grower_phone_canceled', {
      contractId: contractData.contract_id,
      growerPhone
    })
  }

  const handleCancelEmailInput = () => {
    setToggleInput(false)
    trackEvent('edit_grower_email_canceled', {
      contractId: contractData.contract_id,
      growerEmail
    })
  }

  const onSubmit = () => {
    if(contractDataPending){
      postContractByIdWithDraft(contract_id)
    }
    contractDataPending ? setSubmissionStatus('SUCCESS') : setSubmissionStatus('SUBMIT')
    if(growerDeliveryChoice.toLowerCase() === 'email') {
      trackEvent('submit_for_signing_clicked', {
        contractId: contractData.contract_id,
        growerEmail
      })
    } else {
      trackEvent('submit_for_signing_clicked', {
        contractId: contractData.contract_id,
        growerPhone
      })
    }
  }

  const handleContinue = () => {
    const yearOfInterest = new Date(
      contractData.contract_start_execution
    ).getFullYear()
    const growerName = `${contractData.contract_details.grower_details.first} ${contractData.contract_details.grower_details.last}`
    const newTitle = `${yearOfInterest} : ${growerName} to ${contractData.contract_details.grain_receiver_details.grain_receiver_name}`
    trackEvent('send_for_signing_continue_clicked', {
      contractId: contractData.contract_id
    })
    dispatch({
      type: 'SENT_FOR_SIGNING',
      payload: {
        company_id: grainReceiverDetails?.sap_id,
        contract_id: contractData.contract_id,
        detailView: { previous: 'Back to PDF', title: newTitle }
      }
    })
  }

  const handleResendContinue = () => {
    setShowModal(false)
    setResendLoading()
  }

  useEffect(() => {
    getHighestRole()?.then(res => {
      setUserInfo(
        { 
          voided_user_info: {
            'user_id': res.user_id,
            'user_name': res.first+ ' ' + res.last,
            'user_email': res.email,
            'system_name': 'GrowMore360'
          },
          voided_from : 'amend_action'
        }
      )
    })
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i.test(growerPhone) && growerDeliveryChoice.toLowerCase() === 'phone') {
      setPhoneError(true)
    } else {
      setPhoneError(false)
    }
  }, [growerPhone,growerDeliveryChoice])

  useEffect(() => {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(growerEmail) && growerDeliveryChoice.toLowerCase() === 'email') {
      setEmailError(true)
    } else {
      setEmailError(false)
    }
  }, [growerEmail, growerDeliveryChoice])

  useEffect(() => {
    const initData = () => {
      getAssignments(grainReceiverDetails.sap_id)?.then(res => {
        const signers = res?.filter(
          user =>{
            if (contractData.contract_details.display_details.contract_type === 'fuel') {
              return user.role_name === 'grain-ops-manager' || user.role_name === 'grain-receiver-approved-signer'
            } else 
            {
              return user.permissions.includes('sign-contract')
            }
          }
        )
          .map(signer => {
            return {
              first_name: signer.first_name,
              last_name: signer.last_name,
              email: signer.email,
              phone: signer.phone,
              signer_role: signer.role,
              user_id: signer.user_id,
              entity_name: grainReceiverDetails.grain_receiver_name,
              role: 'receiver',
              assignment_role: signer.role_name //added this role
            }
          })
        if (!canceled.current) {
          setGrainReceiverData(signers)
        }
      })
    }
    if (grainReceiverDetails.sap_id) {
      initData()
    }
  }, [grainReceiverDetails.sap_id, grainReceiverDetails.grain_receiver_name])

  useEffect(() => {
    const initData = () => {
      if (contractData.contract_details.display_details.contract_type !== 'fuel') {
        getAssignments(resellerDetails.reseller_id)?.then(res => {
          const signers = res?.filter(user =>{
            return user.permissions.includes('approve-contract') && user.role_name !== "account-lead"
          }
          )
            .map(signer => {
              return {
                first_name: signer.first_name,
                last_name: signer.last_name,
                email: signer.email,
                phone: signer.phone,
                signer_role: signer.role,
                user_id: signer.user_id,
                is_approver: true,
                entity_name: resellerDetails.reseller_name,
                role: 'reseller'
              }
            })
          if (!canceled.current) {
            setResellerData(signers)
          }
        })
      } else {
        setResellerData([])
      }
      
    }
    if (resellerDetails.reseller_id) {
      initData()
    }
  }, [resellerDetails.reseller_id, resellerDetails.reseller_name])

  useEffect(() => {
    if (submissionStatus === 'SUBMIT') {
      const growerName =
        growerDetails && growerDetails.first && growerDetails.last
          ? [growerDetails.first, growerDetails.last]
          : ['N/A', 'N/A']

      let growerData = {}
      if(growerDeliveryChoice.toLowerCase()==='email') {
        growerData = {
          contract_id: contractData.contract_id,
          external_reference_id: growerDetails.sap_id,
          first_name: growerName[0],
          last_name: growerName[1],
          email: growerEmail,
          docusign_type: 'signers',
          delivery_choice: growerDeliveryChoice.toLowerCase()==='email'?'email' : 'phone',
          entity_name: `${growerName[0]} ${growerName[1]}`,
          role: 'grower'
        }
      } else {
        growerData = {
          phone: reducePhoneNumber(growerPhone),
          contract_id: contractData.contract_id,
          external_reference_id: growerDetails.sap_id,
          first_name: growerName[0],
          last_name: growerName[1],
          docusign_type: 'signers',
          delivery_choice: growerDeliveryChoice.toLowerCase()==='email'?'email' : 'phone',
          entity_name: `${growerName[0]} ${growerName[1]}`,
          role: 'grower'
        }
      }

      const approvers = resellerData?.map(signer => {
        const returnable = {
          contract_id: contractData.contract_id,
          external_reference_id: signer.user_id,
          first_name: signer.first_name || 'N/A',
          last_name: signer.last_name || 'N/A',
          email: signer.email,
          docusign_type: 'signers',
          delivery_choice: 'email',
          is_approver: signer.is_approver,
          entity_name: signer.entity_name,
          role: signer.role
        }
        let newPhone = reducePhoneNumber(signer.phone)
        if (newPhone !== 'N/A') {
          returnable.phone = reducePhoneNumber(signer.phone)
        }
        return returnable
      })

      const companySigners = grainReceiverData?.map(signer => {
        const returnable = {
          contract_id: contractData.contract_id,
          external_reference_id: signer.user_id,
          first_name: signer.first_name || 'N/A',
          last_name: signer.last_name || 'N/A',
          email: signer.email,
          docusign_type: 'signers',
          delivery_choice: 'email',
          is_approver: false,
          entity_name: signer.entity_name,
          role: signer.role,
          assignment_role: signer.assignment_role
        }
        let newPhone = reducePhoneNumber(signer.phone)
        if (newPhone !== 'N/A') {
          returnable.phone = reducePhoneNumber(signer.phone)
        }
        return returnable
      })
      let arrayOfSigners = [growerData, ...companySigners, ...approvers]
      arrayOfSigners = arrayOfSigners.filter(s => s.last_name !== 'Reddy' && s.phone !== '13035198382')
      !contractDataPending && setSubmissionStatus('LOADING')
      !contractDataPending && sendToSign(arrayOfSigners,contractData?.parent_voided_contract_id,userInfo)?.then(res => {
        if (res) {
          if (!canceled.current) {
            setDisableSentSignBtn(true)
            setSubmissionStatus('SUCCESS')
            trackEvent('send_for_signing_succeeded', {
              contractId: contractData.contract_id,
              res
            })
          }
        } else {
          if (!canceled.current) {
            trackEvent('send_for_signing_failed', {
              contractId: contractData.contract_id
            })
            setSubmissionStatus('EMPTY')
          }
        }
      })
    }
  }, [growerDetails, growerPhone, growerEmail, growerDeliveryChoice, submissionStatus, grainReceiverData, reset, clearError, contractData.contract_id, resellerDetails, grainReceiverDetails.external_reference_id, trackEvent, resellerData, contractDataPending, setDisableSentSignBtn])

  const handleDeliveryChoice = value => {
    setGrowerDeliveryChoice(value)
    if(value.toLowerCase() === 'email') {
      setPhoneError(false)
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(growerEmail))
        setEmailError(true)
    }
    else {
      setEmailError(false)
      if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i.test(growerPhone))
        setPhoneError(true)
  
    }
  }

  const populateGrower = () => {
    const growerName = `${growerDetails.first} ${growerDetails.last}`
    const listOfDeliveryChoice = ['Email', 'Phone']
    return (
      <div className="fz15 df fxdrr tal mt15 mb15 aic">
        <div className="df flx1">Grower</div>
        <div className="df flx2">{growerName}</div>
        <div className="df flx3">
          <form onSubmit={handleSubmit(growerDeliveryChoice.toLowerCase() === 'email' ? handleConfirmEmail : handleConfirmPhoneNumber)} className="posr" style={{ width:'98%' }}>
            <div>
              {growerDeliveryChoice.toLowerCase() === 'email' ? 
                (toggleInput ? renderEditEmailInput() : 
                  (growerEmail === '') ? 'N/A' : growerEmail
                ) : 
                (toggleInput ? renderEditInput() :
                  (growerPhone === '')? 'N/A' : growerPhone       
                )
              }
              {toggleInput ? 
                null : 
                !contractDataPending ? 
                  <span className="tdu c-blue-700 ml10 curp" onClick={inputDecider}>edit</span> 
                  : null
              }
            </div>
          </form>
        </div>
        <div className="df flx2">
          {toggleInput ?
            <Controller
              as={<Select defaultValue={growerDeliveryChoice.toLowerCase() === 'email' ? 'Email' : 'Phone'} />}
              placeholder="Select a state"
              handleSelection={handleDeliveryChoice}
              options={listOfDeliveryChoice}
              control={control}
              name="delivery_Choice"
              aria-label="delivery_Choice"
            /> : growerDeliveryChoice.toLowerCase() === 'email' ? <div className="w100">Email</div> : <div className="w100">Phone</div>
          }
        </div>
      </div>
    )
  }

  const renderEditInput = () => {
    const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i
    return (
      <>
        <div className="df w70 jcspb posa r0 mt8">
          <button
            className="mb0 bdnone bgc-t curp"
            onClick={handleConfirmPhoneNumber}
          >
            <img src={checkIcon} alt="confirm icon" />
          </button>
          <button
            type="button"
            className="mb0 bdnone bgc-t curp"
            onClick={handleCancelInput}
          >
            <img src={closeIcon} alt="cancel icon" />
          </button>
        </div>
        <input
          name="phone"
          placeholder='919-999-999'
          onChange={handlePhoneNumber}
          value={growerPhone}
          ref={register({ required: true, pattern: phoneRegex })}
        />

          
        {errors.phone &&
              errors.phone.type === 'required' &&
              <div className="c-red tal fz13">Please provide grower&apos;s phone number</div>}
        {errors.phone &&
              errors.phone.type === 'pattern' &&
              <div className="c-red tal fz13">Please providesss a valid phone number ex. 919-999-9999, limited to 10 digits</div>}
      </>
    )
  }


  const renderEditEmailInput = () => {
    const phoneRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    return (
      <>
        <div className="df w70 jcspb posa r0 mt8">
          <button
            className="mb0 bdnone bgc-t curp"
            onClick={handleConfirmEmail}
          >
            <img src={checkIcon} alt="confirm icon" />
          </button>
          <button
            type="button"
            className="mb0 bdnone bgc-t curp"
            onClick={handleCancelEmailInput}
          >
            <img src={closeIcon} alt="cancel icon" />
          </button>
        </div>
        <input
          name="email"
          placeholder='example@domain.com'
          onChange={handleEmail}
          value={growerEmail}
          ref={register({ required: true, pattern: phoneRegex })}
        />

        {errors.email &&
          errors.email.type === 'required' &&
          <div className="c-red tal fz13">Please provide grower&apos;s email address</div>}
        {errors.email &&
          errors.email.type === 'pattern' &&
          <div className="c-red tal fz13">Please enter a valid email address</div>}
      </>
    )
  }

  const populateSigner = () => {
    const signers = []
    if (grainReceiverData) {
      grainReceiverData.forEach(signer => {
        signers.push(
          <div key={signer.email} className="fz15 df fxdrr tal mt15 mb15">
            <div className="df flx1">{signer.signer_role}</div>
            <div className="df flx2">{`${signer.first_name} ${signer.last_name}`}</div>
            <div className="df flx3">{signer.email}</div>
            <div className="df flx2"></div>
          </div>
        )
      })
    }
    if (resellerData && resellerData.length > 0) {
      signers.push(<hr className=" bdnone bt1-s-lightgray" />)
      resellerData.forEach(signer => {
        signers.push(
          <div key={signer.email} className="fz15 df fxdrr tal mt15 mb15">
            <div className="df flx1">{signer.signer_role}</div>
            <div className="df flx2">{`${signer.first_name} ${signer.last_name}`}</div>
            <div className="df flx3">{signer.email}</div>
            <div className="df flx2"></div>
          </div>
        )
      })
    }
    return signers
  }

  const setBottomRow = (left, right) => {
    return (
      <>
        <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
        <div className="df jcfe">
          {left}
          {right}
        </div>
      </>
    )
  }

  let phoneErrorBottomRow = setBottomRow(null, <Button
    type="success"
    text="Okay"
    clickHandler={hideModal}
    customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
  />)

  let phoneErrorContent = (
    <>
      <div className="m20">
        <div className="fz15 tal mb20 tac">
          <span>
            The phone number is not available for resend. Please amend or void this contract in order to update the signers.
          </span>
        </div>
      </div>
    </>
  )

  let content = (
    <>
      <div className="m20">
        <div className="fz15 tal mb20">
          <span>
            This contract will be sent to the following people to be signed:
          </span>
        </div>
        <div className="df fxdrr tal fz14 c-darkgray fw500">
          <div className="df flx1">Role</div>
          <div className="df flx2" style={{ width:'130px' }}>Name</div>
          <div className="df flx3">Method of contact</div>   
          <div className="df flx2">Delivery Choice</div>  
        </div>
        <hr className=" bdnone bt1-s-lightgray" />
        {populateGrower()}
        {!resend && !contractDataPending && populateSigner()}
        {phoneError && (
          <>
            <hr className=" bdnone bt1-s-lightgray" />
            <div className="c-red tal fz13">
              <p>Please provide a valid phone number <br />ex. 919-999-9999, limited to 10 digits</p>
            </div>
          </>
        )}
        {emailError && (
          <>
            <hr className=" bdnone bt1-s-lightgray" />
            <div className="c-red tal fz13">
              <p>Please enter a valid email address</p>
            </div>
          </>
        )}
      </div>
    </>
  )

  let rightButton = (
    <Button
      disabled={phoneError || emailError}
      type="success"
      text={contractDataPending ? 'Resend' : 'Submit for signing'}
      clickHandler={onSubmit}
      customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
    />
  )
  let leftButton = (
    <Button
      text="Cancel"
      customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
      clickHandler={handleCancelModal}
    />
  )

  let bottomRow = setBottomRow(leftButton, rightButton)
  if(resend) {
    switch (resendSubmissionStatus) {
      case 'LOADING':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              <span>Please wait...</span>
            </div>
            <TableStatus
              status="LOADING"
              prompt="Please wait..."
            />
          </div>)
        bottomRow = null
        break
      case 'SUCCESS':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              { 
                <span>Successfully Resend!</span>
              }
            </div>
          </div>
        )
        bottomRow = null
        leftButton = null
        rightButton = (
          <Button
            type="success"
            text="Continue"
            clickHandler={handleResendContinue}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        )
        bottomRow = setBottomRow(leftButton, rightButton)
        break
      case 'ERROR':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              <span>{resendMessage ? resendMessage : 'Whoops! Resend Failed.' }</span>
            </div>
          </div>
        )
        bottomRow = null
        leftButton = null
        rightButton = (
          <Button
            type="success"
            text="Continue"
            clickHandler={handleResendContinue}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        )
        bottomRow = setBottomRow(leftButton, rightButton)
        break
      default:
        rightButton = (
          <Button
            disabled={phoneError || emailError}
            type="success"
            text="Resend notifications"
            clickHandler={() => {handleResend(growerPhone, growerEmail, growerDeliveryChoice, contractData, growerSigner?.contract_signer_id)}}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />)
        bottomRow = setBottomRow(leftButton, rightButton)
        break
    }
  }

 

  if(!resend) {
    switch (submissionStatus) {
      case 'LOADING':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              <span>Adding signers. Please wait...</span>
            </div>
            <TableStatus
              status="LOADING"
              prompt="Adding signers. Please wait..."
            />
          </div>)
        bottomRow = null
        break
      case 'SUCCESS':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              {
                contractDataPending ? 
                  <span>Successfully Resend!</span> :
                  <span>Signers successfully added!</span>
              }
            </div>
          </div>
        )
        bottomRow = null
        leftButton = null
        rightButton = (
          <Button
            type="success"
            text="Continue"
            clickHandler={handleContinue}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        )
        bottomRow = setBottomRow(leftButton, rightButton)
        break
      case 'EMPTY':
        content = (
          <div className="m20">
            <div className="df jcc fz15 tal mb20">
              <span>Something went wrong. Please contact your admin.</span>
            </div>
          </div>
        )
        rightButton = (
          <Button
            type="success"
            text="Continue"
            clickHandler={handleContinue}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        )
        bottomRow = setBottomRow(leftButton, rightButton)
        break
      default:
        break
    }
  }

  return (
    <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4">
      <div className="df jcsb">
        <p className="fz16 ml16 fw600">{contractDataPending && phoneError ? '' : resend? 'Resend for signing': 'Send for signing' }</p>
        {submissionStatus !== 'LOADING' && (
          <button className="bdnone m0 bgc-t" onClick={handleCancelModal}>
            <img src={clear} alt="cancel button" />
          </button>
        )}
      </div>
      <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
      {contractDataPending && phoneError ? phoneErrorContent : content}
      {contractDataPending && phoneError ? phoneErrorBottomRow : bottomRow}
    </div>
  )
}

export default withRouter(SendForSigningForm)